import { render } from "./Main_health.vue?vue&type=template&id=240cbdce"
import script from "./Main_health.vue?vue&type=script&lang=js"
export * from "./Main_health.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__